import Axios from 'axios';
import createSocketConnection from "../socket/socket";
import useStore from "../zustand/useStore";
const api = Axios.create({
    baseURL: 'https://caworld.org/api-ca-world/common/',
    withCredentials:true
})


export const actionToConnectSocketServer = () => {
    const socket = createSocketConnection();
    socket.on('connect', () => {
        console.log('Connected to socket server:', socket.id);
    });

    socket.on('message', (data) => {
        let websocketData = JSON.parse(data);
        console.log('websocketData',websocketData)
    });

    socket.on('disconnect', () => {
        console.log('Disconnected from socket server');
    });
}

export const actionToGetCurrentLatestNewsCategories = () => {
    const {requestNewsCategory,setNewsCategoryData} = useStore.getState();
    requestNewsCategory();
    api.post(`actionToGetCurrentLatestNewsCategoriesApiCall`, {},{ withCredentials: true }).then(responseData => {
        setNewsCategoryData(responseData?.data);
    })
}

export const actionToGetAllNewsCategoriesAdmin = (isLoading = true) => {
    const {requestNewsCategory,setNewsCategoryData} = useStore.getState();
    if(isLoading){
        requestNewsCategory();
    }
    api.post(`actionToGetAllNewsCategoriesApiCall`, {},{ withCredentials: true }).then(responseData => {
        setNewsCategoryData(responseData?.data);
    })
}

export const actionToCreateNewsCategory = async (payload) => {
    // payload: { name, slug?, ordering }
    const res = await api.post(
        'actionToCreateNewsCategoryApiCall',
        payload,                  // send the object directly (NO { payload })
        { withCredentials: true }
    );
    return res.data;
};

export const actionToDeleteNewsCategory = async (id) => {
    // payload: { name, slug?, ordering }
    const res = await api.post(
        'actionToDeleteNewsCategoryApiCall',
        {id},                  // send the object directly (NO { payload })
        { withCredentials: true }
    );
    return res.data;
};

export const actionToMarkUnmarkBookmarkNewsData = async (payload,is_bookmarked) => {
    const {updateBookmarkStatus} = useStore.getState();
    updateBookmarkStatus(payload.news_id, !is_bookmarked);
    const res = await api.post(
        'actionToMarkUnmarkBookmarkNewsDataApiCall',
        payload,
        { withCredentials: true }
    );
    return res.data;
};

export const actionToUpdateNewsCategory = async (id, payload) => {
    // id: number | string
    // payload: { name?, slug?, ordering? }
    const res = await api.post(
        'actionToUpdateNewsCategoryApiCall',
        { id, ...(payload ?? {}) },       // include id at root with updated fields
        { withCredentials: true }
    );
    return res.data;
};

export const actionToGetUserSessionData = () => {
    const {startUserSession,setUserSession,signinSuccess} = useStore.getState();
    startUserSession();
    try {
        api.post(`actionToGetCurrentUserSessionDataApiCall`, {},{ withCredentials: true }).then(responseData => {
            if(responseData?.data?.success){
                signinSuccess({...(responseData?.data?.userData ?? {})});
                setUserSession(1);
            }else{
                setUserSession(0)
            }
        })
    } catch (error) {
        setUserSession(0);
    }
}

export const actionToCreateContributionOrder = async (amount,formData) => {
    return await api.post(
        `actionToCreateContributionOrderApiCall`,
        { amount ,formData},
        { withCredentials: true }
    );
};

export const actionToCreateMemberShipOrder = async (payload) => {
    return await api.post(
        `actionToCreateMemberShipOrderApiCall`,
        payload,
        { withCredentials: true }
    );
};

export const actionToPermanentlyAccountDeletion = async () => {
    await api.post(
        `actionToPermanentlyAccountDeletionApiCall`,
        { withCredentials: true }
    );
    actionToLogoutUserSession();
};

export const actionToVerifyMembershipOrderPayment = async (razorpayData) => {
    return await api.post(
        `actionToVerifyMembershipOrderPaymentApiCall`,
        {
            razorpay_order_id: razorpayData.razorpay_order_id,
            razorpay_payment_id: razorpayData.razorpay_payment_id,
            razorpay_signature: razorpayData.razorpay_signature
        },
        { withCredentials: true }
    );
};

export const actionToCreateEventPurchaseOrder = async (payload) => {
    return await api.post(
        `actionToCreateEventPurchaseOrderApiCall`,
        payload,
        { withCredentials: true }
    );
};

export const actionToVerifyEventPayment = async (razorpayData) => {
    return await api.post(
        `actionToVerifyEventPaymentApiCall`,
        {
            razorpay_order_id: razorpayData.razorpay_order_id,
            razorpay_payment_id: razorpayData.razorpay_payment_id,
            razorpay_signature: razorpayData.razorpay_signature
        },
        { withCredentials: true }
    );
};

export const actionToVerifyContributionOrderPayment = async (formData, razorpayData) => {
    return await api.post(
        `actionToVerifyContributionOrderPaymentApiCall`,
        {
            formData, // your contribution form fields
            razorpay_order_id: razorpayData.razorpay_order_id,
            razorpay_payment_id: razorpayData.razorpay_payment_id,
            razorpay_signature: razorpayData.razorpay_signature
        },
        { withCredentials: true }
    );
};

// CommonAction.js
export const actionToMarkContentRead = async (content_type, content_id) => {
    return api.post(`actionToMarkContentReadApiCall`, {content_type, content_id}, { withCredentials: true });
};

export const actionToRegisterDeviceToken = async ({ token, platform }) => {
    try {
        await api.post(
            `actionToRegisterDeviceTokenApiCall`,
            { token, platform },
            { withCredentials: true }
        );
    } catch (err) {
        console.warn('Device token registration failed', err?.message || err);
    }
};


export const actionToGetNewsDataByCategoryFilter = (category,bookmarkedOnly = false) => {
    const {setNewsDetailDataListLoading,setNewsDetailDataListSuccess} = useStore.getState();
    setNewsDetailDataListLoading();
    api.post(`actionToGetNewsDataByCategoryFilterApiCall`, {category,offset:0,bookmarkedOnly},{ withCredentials: true }).then(responseData => {
        const list = Array.isArray(responseData?.data)
            ? responseData.data
            : (responseData?.data ? [responseData.data] : []);

        setNewsDetailDataListSuccess({
            newsDetailList: list,
            offset: 0,
        });
    })
}

export const actionToGetUserJobProfileData = () => {
    const {requestUserJobProfileData,setUserJobProfileData} = useStore.getState();
    requestUserJobProfileData();
    api.post(`actionToGetUserJobProfileDataApiCall`, {},{ withCredentials: true }).then(responseData => {
        setUserJobProfileData({...(responseData?.data ?? {})});
    })
}

export const actionToGetUserJobPostData = () => {
    const {requestUserJobPostData,setUserJobPostData} = useStore.getState();
    requestUserJobPostData();
    api.post(`actionToGetJobPostingByFilterApiCall`, {limit:10,offset:0,me_mode:true,user_type:1},{ withCredentials: true }).then(responseData => {
        setUserJobPostData([...(responseData?.data?.data ?? [])]);
    })
}

export const actionToGetOtherUsersJobPostData = () => {
    const {requestOtherUsersJobPostData,setOtherUsersJobPostData} = useStore.getState();
    requestOtherUsersJobPostData();
    api.post(`actionToGetJobPostingByFilterApiCall`, {limit:10,offset:0,user_type:1},{ withCredentials: true }).then(responseData => {
        setOtherUsersJobPostData([...(responseData.data.data ?? [])]);
    })
}

export const actionToGetUserAssignmentPostData = () => {
    const {requestUserAssignmentPostData,setUserAssignmentPostData} = useStore.getState();
    requestUserAssignmentPostData();
    api.post(`actionToGetRfpAssignmentDataByFilterApiCall`, {limit:10,offset:0,me_mode:true},{ withCredentials: true }).then(responseData => {
        setUserAssignmentPostData([...(responseData.data.data ?? [])]);
    })
}

export const actionToGetOtherUsersAssignmentPostData = () => {
    const {requestOtherUsersAssignmentPostData,setOtherUsersAssignmentPostData} = useStore.getState();
    requestOtherUsersAssignmentPostData();
    api.post(`actionToGetRfpAssignmentDataByFilterApiCall`, {limit:10,offset:0},{ withCredentials: true }).then(responseData => {
        setOtherUsersAssignmentPostData([...(responseData.data.data ?? [])]);
    })
}

export const actionToGetUserMatrimonialProfileData = () => {
    const {requestUserMatrimonialProfileData,setUserMatrimonialProfileData} = useStore.getState();
    requestUserMatrimonialProfileData();
    api.post(`actionToGetMatrimonialPostingByFilterApiCall`, {limit:10,offset:0,me_mode:true},{ withCredentials: true }).then(responseData => {
        setUserMatrimonialProfileData([...(responseData.data.data ?? [])]);
    })
}

export const actionToGetOtherUsersMatrimonialProfileData = () => {
    const {requestOtherUsersMatrimonialProfileData,setOtherUsersMatrimonialProfileData,userAuthDetail} = useStore.getState();
    requestOtherUsersMatrimonialProfileData();
    api.post(`actionToGetMatrimonialPostingByFilterApiCall`, {limit:10,offset:0,gender_code:userAuthDetail?.userInfo?.matrimonial_portal_role},{ withCredentials: true }).then(responseData => {
        setOtherUsersMatrimonialProfileData([...(responseData.data.data ?? [])]);
    })
}

export const actionToGetNewsDataByCategoryFilterOffset = (category,bookmarkedOnly = false) => {
    const { newsDetailDataList, setNewsDetailDataListSuccess } = useStore.getState();
    const prevList = newsDetailDataList.newsDetailList || [];
    const offset = (newsDetailDataList.offset || 0) + 20;
    api.post(
            `actionToGetNewsDataByCategoryFilterApiCall`,
            { category, offset,bookmarkedOnly },
            { withCredentials: true }
        )
        .then((responseData) => {
            const next = responseData?.data || [];
            setNewsDetailDataListSuccess({
                newsDetailList: [...(prevList ?? []), ...(next ?? [])],
                offset,
            });
        });
}

export const actionToGetBookmarkedNewsDataByCategoryFilter = () => {
    const {setBookmarkedNewsDetailDataListLoading,setBookmarkedNewsDetailDataListSuccess} = useStore.getState();
    setBookmarkedNewsDetailDataListLoading();
    api.post(`actionToGetBookmarkedNewsDataByCategoryFilterApiCall`, {offset:0},{ withCredentials: true }).then(responseData => {
        setBookmarkedNewsDetailDataListSuccess({newsDetailList:[...(responseData?.data ?? [])],offset:0});
    })
}

export const actionToGetBookMarkedNewsDataByCategoryFilterOffset = () => {
    const {setBookmarkedNewsDetailDataListSuccess,bookmarkedNewsDetailDataList} = useStore.getState();
    const prevList = bookmarkedNewsDetailDataList?.newsDetailList || [];
    const offset = (bookmarkedNewsDetailDataList.offset || 0) + 20;
    api.post(
            `actionToGetBookmarkedNewsDataByCategoryFilterApiCall`,
            { offset },
            { withCredentials: true }
        )
        .then((responseData) => {
            const next = responseData?.data || [];
            setBookmarkedNewsDetailDataListSuccess({
                newsDetailList: [...prevList, ...next],
                offset,
            });
        });
}

export const actionToGetAllNewsCategories = () => {
    const {setJobAppliedMemberDataList} = useStore.getState();
    setJobAppliedMemberDataList([]);
    api.post(`actionToGetAllNewsCategoriesApiCall`, {withCredentials: true}).then(responseData => {
        setJobAppliedMemberDataList(responseData.data);
    })
}


export const actionToGetAllJobAppliedMemberList = (memberIdArray) => {
    const {setJobAppliedMemberDataList} = useStore.getState();
    setJobAppliedMemberDataList([]);
    if(memberIdArray?.length) {
        api.post(`actionToGetAllJobAppliedMemberListApiCall`, memberIdArray, {withCredentials: true}).then(responseData => {
            setJobAppliedMemberDataList(responseData.data);
        })
    }
}

export const actionToLogoutUserSession = () => {
    const {signOut,setUserSession} = useStore.getState();
    try {
        api.post(`actionToLogoutUserSessionApiCall`, {}).then(() => {
            if(setUserSession)
              setUserSession(0);
            if(signOut)
              signOut();
        })
    } catch (error) {
        console.log('error',error)
    }
}

export const actionToGetNewsById = async (id) => {
    try {
        const {data} = await api.post(`actionToGetNewsByIdApiCall`, {id});
        return data;
    } catch (error) {
        console.log('error',error)
    }
}

export const actionToGetJobDataById = async (id) => {
    try {
        const {data} = await api.post(`actionToGetJobDataByIdApiCall`, {id});
        return data;
    } catch (error) {
        console.log('error',error)
    }
}

export const actionToGetAssignmentDataById = async (id) => {
    try {
        const {data} = await api.post(`actionToGetAssignmentDataByIdApiCall`, {id});
        return data;
    } catch (error) {
        console.log('error',error)
    }
}

export const actionToGetDeservingCandidatesData = async () => {
    try {
        const {data} = await api.post(`actionToGetJobPostingByFilterApiCall`, {limit:10,offset:0,user_type:2});
        return data;
    } catch (error) {
        console.log('error',error)
    }
}

export const actionToGetOtherUsersJobProfileData = () => {
    const {requestOtherUsersJobProfileData,setOtherUsersJobProfileData} = useStore.getState();
    requestOtherUsersJobProfileData();
    api.post(`actionToGetJobPostingByFilterApiCall`, {limit:10,offset:0,user_type:2},{ withCredentials: true }).then(responseData => {
        setOtherUsersJobProfileData([...(responseData?.data?.data ?? [])]);
    })
}

export const actionToGetEventDataById = async (id) => {
    try {
        const {data} = await api.post(`actionToGetEventDataByIdApiCall`, {id});
        return data;
    } catch (error) {
        console.log('error',error)
    }
}

export const actionToSendOtp = (formData) =>  {
    const {setSignupSigninError,getOtpFail,getOtpRequest,getOtpSuccess} = useStore.getState();
    getOtpRequest();
    try {
        api.post(`actionToSendOtpApiCall`, formData).then(responseData => {
            if(responseData?.data?.success){
                getOtpSuccess();
            }else{
                getOtpFail();
                setSignupSigninError({error: responseData?.data?.error, message: responseData?.data?.message})
            }
        })
    } catch (error) {
        getOtpFail();
        console.log(error);
    }
}

export const actionToSendForgotPasswordOtp = (formData) =>  {
    const {setSignupSigninError,getOtpFail,getOtpRequest,getOtpSuccess} = useStore.getState();
    getOtpRequest();
    try {
        api.post(`actionToSendForgotPasswordOtpApiCall`, formData).then(responseData => {
            if(responseData?.data?.success){
                getOtpSuccess();
            }else{
                getOtpFail();
                setSignupSigninError({error: responseData?.data?.error, message: responseData?.data?.message})
            }
        })
    } catch (error) {
        getOtpFail();
        console.log(error);
    }
}

export const actionToVerifyResetPasswordOtpAndSavePass = (formData,history) =>  {
    const {setOtpValidationError,getOtpFail} = useStore.getState();
    try {
        api.post(`actionToVerifyResetPasswordOtpAndSavePassApiCall`, formData).then(responseData => {
            if(responseData?.data?.success){
                history.replace('/login');
            }else{
                setOtpValidationError(true);
                getOtpFail();
            }
        })
    } catch (error) {
        getOtpFail();
        console.log(error);
    }
}

export const actionToGetActiveUserMembershipById = async () => {
    const {getCurrentMemberMemberShipDetailRequest,getCurrentMemberMemberShipDetailSuccess} = useStore.getState();
    getCurrentMemberMemberShipDetailRequest();
    try {
        api.post(`actionToGetActiveUserMembershipByIdApiCall`).then(responseData => {
            getCurrentMemberMemberShipDetailSuccess(responseData?.data)
        })
    } catch (error) {
        console.log(error);
    }
};

export const actionToVerifyOtpAndSaveData = (formData,otp) =>  {
    const {setOtpValidationError,getOtpFail} = useStore.getState();
    try {
        api.post(`actionToVerifyOtpAndSaveDataApiCall`, {formData,otp}).then(responseData => {
            if(responseData?.data?.success){
                actionToGetUserSessionData();
            }else{
                setOtpValidationError(true);
                getOtpFail();
            }
        })
    } catch (error) {
        getOtpFail();
        console.log(error);
    }
}

export const actionToUploadAdminNewsData = async (payload) => {
    return await api.post(`actionToUploadAdminNewsDataApiCall`, payload);
}

export const actionToAddUser = async (payload) => {
    return await api.post(`actionToAddUserApiCall`, payload);
}

export const actionToUpdateUser = async (payload) => {
    return await api.post(`actionToUpdateUserApiCall`, payload);
}

export const actionToAddUpdateUserMembershipStatus = async (payload) => {
    return await api.post(`actionToAddUpdateUserMembershipStatusApiCall`, payload);
}

export const actionToUpdateAdminNewsData = async (payload) => {
    return await api.post(`actionToUpdateAdminNewsDataApiCall`, payload);
}

export const actionToUploadUserJobProfileData = async (payload) => {
    return await api.post(`actionToUploadUserJobProfileDataApiCall`, payload);
}

export const actionToUpdateUserJobProfileData = async (payload) => {
    return await api.post(`actionToUpdateUserJobProfileDataApiCall`, payload);
}

export const actionToUpdateUserData = async (payload) => {
    await api.post(`actionToUpdateUserDataApiCall`, payload);
    actionToGetUserSessionData();
}

export const actionToUploadUserMatrimonialProfileData = async (payload) => {
    return await api.post(`actionToUploadUserMatrimonialProfileDataApiCall`, payload);
}

export const actionToEditUpdateUserMatrimonialProfileData = async (payload) => {
    return await api.post(`actionToEditUpdateUserMatrimonialProfileDataApiCall`, payload);
}

export const actionToUploadJobPortalDataWithImage = async (payload) => {
    return await api.post(`actionToUploadJobPortalDataWithImageApiCall`, payload);
}

export const actionToEditUpdateJobPortalDataById = async (payload) => {
    return await api.post(`actionToEditUpdateJobPortalDataByIdApiCall`, payload);
}

export const actionToUploadNewsLetterPortalDataWithPdf = async (payload) => {
    return await api.post(`actionToUploadNewsLetterPortalDataWithPdfApiCall`, payload);
}

export const actionToUpdateNewsLetterPortalDataWithPdf = async(payload) => {
    return await api.post(`actionToUpdateNewsLetterPortalDataWithPdfApiCall`, payload);
}

export const actionToUploadEventDataWithPdf = async (payload) => {
    return await api.post(`actionToUploadEventDataWithPdfApiCall`, payload);
}

export const actionToUpdateEventDataWithPdf = async(payload) =>{
    return await api.post('actionToUpdateEventDataWithPdfApiCall', payload);
}

export const actionToUploadRfpAssignmentDataWithAttachment = async (payload) => {
    return await api.post(`actionToUploadRfpAssignmentDataWithAttachmentApiCall`, payload);
}

export const actionToEditUpdateRfpAssignmentDataById = async (payload) => {
    return await api.post(`actionToEditUpdateRfpAssignmentDataByIdApiCall`, payload);
}

export const actionToLoginUserViaLoginEmailPhoneAndPass = (emailOrPhone,password)  => {
    const {signinRequest,signinSuccess,setSignupSigninError,setShowBecomeMemberPopup } = useStore.getState();
    signinRequest();
    try {
        api.post(`actionToLoginUserViaLoginEmailPhoneAndPassApiCall`, {emailOrPhone, password}).then(responseData => {
            if(responseData?.data?.success){
                signinSuccess({...(responseData?.data?.userData ?? {})});
                setShowBecomeMemberPopup(true);
            }else{
                signinSuccess({});
                setSignupSigninError({error: responseData?.data?.error, message: responseData?.data?.message});
            }
        })
    } catch (error) {
        signinSuccess({});
        setSignupSigninError({error:error.response && error.response?.data.message
            ? error.response?.data.message
            : error.message});
    }
}


export const actionToDeleteNewsPostData = async (id) => {
    await api.post(`actionToDeleteNewsPostDataApiCall`, {id});
    actionToGetNewsByFilter();
}

export const actionToDeleteMatrimonialPostData = async (id,userId) => {
    const {userAuthDetail} = useStore.getState();
    await api.post(`actionToDeleteMatrimonialPostDataApiCall`, {id,user_id:userId});
    if(userAuthDetail?.userInfo?.role === 1){
        actionToGetAdminMatrimonialPostingByFilter();
    }else{
        actionToGetUserSessionData();
    }
}

export const actionToApproveMatrimonialPostData = async (id,user_email) => {
    await api.post(`actionToApproveMatrimonialPostApiCall`, {id,user_email});
    actionToGetAdminMatrimonialPostingByFilter();
}

export const actionToDeleteAssignmentPostData = async (id) => {
    await api.post(`actionToDeleteAssignmentPostDataApiCall`, {id});
    actionToGetRfpAdminAssignmentDataByFilter();
}

// ✅ Mark notification as seen (remove it from state)
export const actionToUpdateNotificationSeen = async (id) => {
    const { setNotificationsSuccess, notificationsDataState } = useStore.getState();
    try {
        await api.post("actionToUpdateNotificationSeenApiCall", { id });

        const updatedNotifications = notificationsDataState.notifications.filter(
            (n) => n.id !== id
        );

        setNotificationsSuccess({
            notifications: updatedNotifications,
        });
    } catch (error) {
        console.error("Error updating notification seen:", error);
    }
};

// ✅ Get all notifications
export const actionToGetAllNotification = async () => {
    const { setNotificationsSuccess, setNotificationsLoading } = useStore.getState();
    setNotificationsLoading()
    try {
        const res = await api.post("actionToGetAllNotificationApiCall");
        setNotificationsSuccess({
            notifications: res?.data || [],
        });
    } catch (error) {
        console.error("Error fetching notifications:", error);
    }
};

// list combos (optionally filtered by event_id)
export const actionToGetEventCombos = async (event_id) => {
    const { data } = await api.post(`actionToGetEventCombosApiCall`, {event_id});
    return data;
};

// list all events lite (for multiselect)
export const actionToGetAllEventsLite = async () => {
    const { data } = await api.post(`actionToGetAllEventsLiteApiCall`, { withCredentials: true });
    return data;
};

// create combo
export const actionToCreateEventCombo = async (payload) => {
    const { data } = await api.post(`actionToCreateEventComboApiCall`, payload, { withCredentials: true });
    return data;
};

// delete combo
export const actionToDeleteEventCombo = async (id) => {
    const { data } = await api.post(`actionToDeleteEventComboApiCall`, { id }, { withCredentials: true });
    return data;
};

// List gallery
export const actionToGetEventGallery = async (event_id) => {
    const { data } = await api.post(`actionToGetEventGalleryApiCall`, { event_id });
    return data;
};

// Upload multiple
export const actionToUploadEventGallery = async (event_id, files) => {
    const fd = new FormData();
    fd.append('event_id', event_id);
    files.forEach(f => fd.append('gallery_images', f));
    const { data } = await api.post(`actionToUploadEventGalleryApiCall`, fd);
    return data;
};

// Delete one image
export const actionToDeleteEventGalleryImage = async (id) => {
    const { data } = await api.post(`actionToDeleteEventGalleryImageApiCall`, { id }, { withCredentials:true });
    return data;
};

export const actionToDeleteEventPostData = async (id) => {
    await api.post(`actionToDeleteEventPostDataApiCall`, {id});
    actionToGetEventsByFilter(true, {all_events:true});
}

export const actionToDeleteUserPostData = async (id) => {
    await api.post(`actionToDeleteUserPostDataApiCall`, {id});
    actionToGetUsersByFilter();
}

export const actionToChangeUserRole = async (id,role) => {
    await api.post(`actionToChangeUserRoleApiCall`, {id,role});
    actionToGetUsersByFilter();
}

export const actionToResetUserPassword = async (id,password) => {
    await api.post(`actionToResetUserPasswordApiCall`, {id,password});
    actionToGetUsersByFilter();
}

export const actionToDeleteNewsLetterPostData = async (id) => {
    await api.post(`actionToDeleteNewsLetterPostDataApiCall`, {id});
    actionToGetNewsLettersByFilter();
}

export const actionToDeleteJobPostData = async (id) => {
    await api.post(`actionToDeleteJobPortalJobPostApiCall`, {id});
    actionToGetAdminJobPostingByFilter(true,{offset:0,user_type:1});
}

export const actionToStoreNotification = async (payload) => {
    await api.post(`actionToStoreNotificationApiCall`, payload);
}

export const actionToDeleteCandidateJobProfilePostData = async (id) => {
    await api.post(`actionToDeleteCandidateJobProfilePostDataApiCall`, {id});
    actionToGetAdminJobPostingByFilter(true,{offset:0,user_type:2});
}

export const actionToDeleteMyJobProfile = async (id) => {
    await api.post(`actionToDeleteCandidateJobProfilePostDataApiCall`, {id});
    actionToGetUserJobProfileData();
}


export const actionToDeleteJobPortalJobPost = async (id) => {
    await api.post(`actionToDeleteJobPortalJobPostApiCall`, {id});
    actionToGetJobPostingByFilter(true,{offset:0,user_type:1,me_mode:true});
    actionToGetUserJobPostData();
}

export const actionToApproveJobPortalJobPost = async (id,user_email,selectedUserType) => {
    if(selectedUserType === 1){
        return await api.post(`actionToApproveJobPortalJobPostApiCall`, {id,user_email});
    }else{
        return await api.post(`actionToApproveJobProfileUserDataApiCall`, {id,user_email});
    }
}

export const actionToDeleteAssignmentPortalPost = async (id) => {
    await api.post(`actionToDeleteAssignmentPortalPostApiCall`, {id});
    actionToGetRfpAssignmentDataByFilter();
    actionToGetUserAssignmentPostData();
}

export const actionToApproveAssignmentPortalPost = async (payload) => {
    await api.post(`actionToApproveAssignmentPostApiCall`, payload);
}

export const actionToApplyForJobPortalJobPost = async (id,applyJson) => {
    const {data} = await api.post(`actionToApplyForJobPortalJobPostApiCall`, {id,applyJson});
    actionToGetJobPostingByFilter();
    actionToGetOtherUsersJobPostData();
    return data?.template;
}

export const actionToGetDeservingCandidateEmailTemplate = async () => {
    const {data} = await api.post(`actionToGetDeservingCandidateEmailTemplateApiCall`);
    return data?.template;
}


export const actionToApplyForMatrimonialProfilePost = async (id,applyJson) => {
    const {data} = await api.post(`actionToApplyForMatrimonialProfilePostApiCall`, {id,applyJson});
    actionToGetJobPostingByFilter();
    actionToGetOtherUsersMatrimonialProfileData();
    return data?.template;
}

export const actionToApplyForAssignmentPortalPost = async (id,applyJson) => {
    const {data} = await api.post(`actionToApplyForAssignmentPortalPostApiCall`, {id,applyJson});
    actionToGetRfpAssignmentDataByFilter();
    actionToGetOtherUsersAssignmentPostData();
    return data?.template;
}

export const actionToGetJobPostingByFilter = async (isLoading = true,payload = {}) => {
    const {
        setJobPostingLoading,
        setJobPostingSuccess,
        setJobPostingFail,
        jobPostingState,
        userAuthDetail
    } = useStore.getState();
    payload.limit = 10;
    let prevJobData = [...(jobPostingState.jobPostings ?? [])];
    if(isLoading){
        payload.offset = 0;
        prevJobData = [];
        setJobPostingLoading();
    }else{
        payload.offset = jobPostingState.offset + 10;
    }

    if(userAuthDetail?.userInfo?.job_portal_role === 1){
        payload.created_by = userAuthDetail?.userInfo?.id;
    }

    if(!payload.user_type)
        payload.user_type = 1;

    try {
        const response = await api.post(`actionToGetJobPostingByFilterApiCall`, payload);
        const jobPostings = response?.data?.data || [];
        setJobPostingSuccess({
            jobPostings:[...prevJobData,...jobPostings],
            offset: payload.offset,
            totalCount: response?.data.totalCount || 0,
        });
    } catch (error) {
        setJobPostingFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

export const actionToGetAdminJobPostingByFilter = async (isLoading = true,payload = {}) => {
    const {
        setJobPostingLoading,
        setJobPostingSuccess,
        setJobPostingFail,
    } = useStore.getState();


    payload.limit = 10;
    if(isLoading){
        setJobPostingLoading();
        payload.offset = 0;
    }

    try {
        const response = await api.post(`actionToGetJobPostingByFilterApiCall`, payload);
        const jobPostings = response?.data?.data || [];
        setJobPostingSuccess({
            jobPostings:[...jobPostings],
            offset: payload.offset,
            totalCount: response?.data.totalCount || 0,
        });
    } catch (error) {
        setJobPostingFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};
export const actionToGetUserContributionByFilter = async(isLoading = true, payload={}) => {
    const {
        setUserContributionLoading,
        setUserContributionSuccess,
        setUserContributionFail,
        userAuthDetail
    } = useStore.getState();

    payload.limit = 10;
    payload.user_id = userAuthDetail?.userInfo?.id;
    if (isLoading) {
        setUserContributionLoading();
        payload.offset = 0;
    }
    try {
        const response = await api.post(`actionToGetUserContributionByFilterApiCall`, payload);
        const contributions = response?.data?.data || [];
        const allContributions = response?.data?.totalData || [];
        setUserContributionSuccess({
            contributions: [...contributions],
            allContributions: [...allContributions],
            offset: payload.offset,
            totalCount: response?.data.totalCount || 0,
        });
    } catch (error) {
        console.log("error", error)
        setUserContributionFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
}
export const actionToGetAdminContributionByFilter = async (isLoading = true, payload = {}) => {
    const {
        setContributionLoading,
        setContributionSuccess,
        setContributionFail,
    } = useStore.getState();

    payload.limit = 10;
    if (isLoading) {
        setContributionLoading();
        payload.offset = 0;
    }

    try {
        const response = await api.post(`actionToGetContributionByFilterApiCall`, payload);
        const contributions = response?.data?.data || [];
        setContributionSuccess({
            contributions: [...contributions],
            offset: payload.offset,
            totalCount: response?.data?.totalCount || 0,
        });
    } catch (error) {
        setContributionFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};



export const actionToGetMemberPanelEventsByFilter = async (isLoading = true, payload = {}) => {
    const {
        eventsDataState,
        setEventsLoading,
        setEventsSuccess,
        setEventsFail,
    } = useStore.getState();

    payload.limit = 20;
    payload.all_events = true;
    let prevStateData = [...(eventsDataState?.eventsData ?? [])];
    if(isLoading){
        payload.offset = 0;
        prevStateData = [];
        setEventsLoading();
    }else{
        payload.offset = eventsDataState.offset + 20;
    }

    try {
        const response = await api.post(`actionToGetEventsByFilterApiCall`, payload);
        let eventsData = response?.data?.data || [];
        eventsData = [...eventsData,...prevStateData]

        setEventsSuccess({
            eventsData: [...eventsData],
            offset: payload.offset,
            totalCount: response?.data.totalCount || 0,
        });
    } catch (error) {
        setEventsFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

export const actionToGetMemberPanelNewsLetterByFilter = async (isLoading = true, payload = {}) => {
    const {
        newsLettersDataState,
        setNewsLettersLoading,
        setNewsLettersSuccess,
        setNewsLettersFail,
    } = useStore.getState();

    payload.limit = 20;
    let prevStateData = [...(newsLettersDataState.newsLettersData ?? [])];
    if(isLoading){
        payload.offset = 0;
        prevStateData = [];
        setNewsLettersLoading();
    }else{
        payload.offset = newsLettersDataState.offset + 20;
    }

    try {
        const response = await api.post(`actionToGetNewsLettersByFilterApiCall`, payload);
        let newsLettersData = response?.data?.data || [];
        newsLettersData = [...newsLettersData,...prevStateData]

        setNewsLettersSuccess({
            newsLettersData: [...newsLettersData],
            offset: payload.offset,
            totalCount: response?.data.totalCount || 0,
        });
    } catch (error) {
        setNewsLettersFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

export const actionToGetNewsLettersByFilter = async (isLoading = true,payload = {}) => {
    const {
        setNewsLettersLoading,
        setNewsLettersSuccess,
        setNewsLettersFail,
    } = useStore.getState();
    payload.limit = 10;
    if(isLoading){
        payload.offset = 0;
        setNewsLettersLoading();
    }
    try {
        const response = await api.post(`actionToGetNewsLettersByFilterApiCall`, payload);
        const newsLetterData = response?.data?.data || [];

        setNewsLettersSuccess({
            newsLettersData:[...newsLetterData],
            offset: payload.offset,
            totalCount: response?.data.totalCount || 0,
        });
    } catch (error) {
        setNewsLettersFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

export const actionToGetEventsByFilter = async (isLoading = true, payload = {}) => {
    const {
        setEventsLoading,
        setEventsSuccess,
        setEventsFail,
    } = useStore.getState();

    payload.limit = 10;
    if (isLoading) {
        payload.offset = 0;
        setEventsLoading();
    }

    try {
        const response = await api.post(`actionToGetEventsByFilterApiCall`, payload);
        const eventsData = response?.data?.data || [];

        setEventsSuccess({
            eventsData: [...eventsData],
            offset: payload.offset,
            totalCount: response?.data.totalCount || 0,
        });
    } catch (error) {
        setEventsFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

export const actionToGetLatestUsersByFilter = async () => {
    const response = await api.post(`actionToGetLatestUsersByFilterApiCall`);
    return response?.data || [];
}
export const actionToGetUsersByFilter = async (isLoading = true, payload = {}) => {
    const {
        setUsersLoading,
        setUsersSuccess,
        setUsersFail,
    } = useStore.getState();

    if(!payload?.limit)
        payload.limit = 10;

    payload.all_users = true;
    if (isLoading) {
        payload.offset = 0;
        setUsersLoading();
    }

    try {
        const response = await api.post(`actionToGetUsersByFilterApiCall`, payload);
        const usersData = response?.data?.data || [];

        setUsersSuccess({
            usersData: [...usersData],
            offset: payload.offset,
            totalCount: response?.data.totalCount || 0,
        });
    } catch (error) {
        setUsersFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

export const actionToGetAllUsersForExport = async ({ limit, totalCount, ...payload } = {}) => {
    const requestPayload = {
        ...payload,
        all_users: true,
        offset: 0,
        limit: limit ?? totalCount ?? 100000,
    };

    const response = await api.post(`actionToGetUsersByFilterApiCall`, requestPayload);
    return response?.data?.data || [];
};


export const actionToGetAdminJobDataByFilter = async (isLoading = true, payload = {}) => {
    const {
        setJobPostingLoading,
        setJobPostingSuccess,
        setJobPostingFail,
    } = useStore.getState();

    payload.limit = 10;
    if (isLoading) {
        payload.offset = 0;
        setJobPostingLoading();
    }

    try {
        const response = await api.post(`actionToGetAdminJobDataByFilterApiCal`, payload);
        const jobData = response?.data?.data || [];

        setJobPostingSuccess({
            jobPostings: [...jobData],
            offset: payload.offset,
            totalCount: response?.data.totalCount || 0,
        });
    } catch (error) {
        setJobPostingFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

export const actionToGetNewsByFilter = async (isLoading = true, payload = {}) => {
    const {
        setNewsLoading,
        setNewsSuccess,
        setNewsFail,
    } = useStore.getState();
    payload.limit = 10;

    if (isLoading) {
        payload.offset = 0;
        setNewsLoading();
    }

    try {
        const response = await api.post(`actionToGetNewsByFilterApiCall`, payload);
        const newsData = response?.data?.data || [];

        setNewsSuccess({
            newsData: [...newsData],
            offset: payload.offset,
            totalCount: response?.data.totalCount || 0,
        });
    } catch (error) {
        setNewsFail(
            error?.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

export const actionToGetAllUsersMemberShipData = async (
    isLoading = true,
    payload = {}
) => {
    const {
        setMemberShipLoading,
        setMemberShipSuccess,
        setMemberShipFail,
    } = useStore.getState();

    payload.limit = 10;

    if (isLoading) {
        payload.offset = 0;
        setMemberShipLoading();
    }

    try {
        const response = await api.post(
            `actionToGetAllUsersMemberShipDataApiCall`,
            payload
        );

        const memberShipData = response?.data?.data || [];

        setMemberShipSuccess({
            memberships: [...memberShipData],
            offset: payload.offset,
            totalCount: response?.data.totalCount || 0,
        });
    } catch (error) {
        setMemberShipFail(
            error?.response?.data?.message || error.message || "Unknown error"
        );
    }
};




export const actionToGetRfpAssignmentDataByFilter = async (isLoading = true,payload = {}) => {
    const {
        setRfpAssignmentLoading,
        setRfpAssignmentSuccess,
        setRfpAssignmentFail,
        rfpAssignmentDataState
    } = useStore.getState();
    payload.limit = 10;
    let prevAssignmentData = [...(rfpAssignmentDataState.assignments ?? [])];
    if(isLoading){
        payload.offset = 0;
        prevAssignmentData = [];
        setRfpAssignmentLoading();
    }else{
        payload.offset = rfpAssignmentDataState.offset + 10;
    }

    try {
        const response = await api.post(`actionToGetRfpAssignmentDataByFilterApiCall`, payload);
        const rpfAssignmentData = response?.data?.data || [];
        setRfpAssignmentSuccess({
            assignments:[...prevAssignmentData,...rpfAssignmentData],
            offset: payload.offset,
            totalCount: response?.data.totalCount,
        });
    } catch (error) {
        setRfpAssignmentFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

export const actionToGetRfpAdminAssignmentDataByFilter = async (isLoading = true,payload = {}) => {
    const {
        setRfpAssignmentLoading,
        setRfpAssignmentSuccess,
        setRfpAssignmentFail,
    } = useStore.getState();
    payload.limit = 10;
    if(isLoading){
        payload.offset = 0;
        setRfpAssignmentLoading();
    }

    try {
        const response = await api.post(`actionToGetRfpAssignmentDataByFilterApiCall`, payload);
        const rpfAssignmentData = response?.data?.data || [];
        setRfpAssignmentSuccess({
            assignments:[...rpfAssignmentData],
            offset: payload.offset,
            totalCount: response?.data.totalCount,
        });
    } catch (error) {
        setRfpAssignmentFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

export const actionToGetMatrimonialPostingByFilter = async (isLoading = true,payload = {}) => {
    const {
        setMatrimonialPostingLoading,
        setMatrimonialPostingSuccess,
        setMatrimonialPostingFail,
        matrimonialPostingState,
        userAuthDetail
    } = useStore.getState();
    payload.limit = 10;
    let prevProfileData = [...(matrimonialPostingState.profiles ?? [])];
    if(isLoading){
        payload.offset = 0;
        prevProfileData = [];
        setMatrimonialPostingLoading();
    }else{
        payload.offset = matrimonialPostingState.offset + 10;
    }

    payload.gender_code = userAuthDetail?.userInfo?.matrimonial_portal_role;

    try {
        const response = await api.post(`actionToGetMatrimonialPostingByFilterApiCall`, payload);
        const matrimonialProfiles = response?.data?.data || [];

        setMatrimonialPostingSuccess({
            profiles:[...prevProfileData,...matrimonialProfiles],
            offset: payload.offset,
            totalCount: response?.data.totalCount,
        });
    } catch (error) {
        setMatrimonialPostingFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

export const actionToGetAdminMatrimonialPostingByFilter = async (isLoading = true,payload = {}) => {
    const {
        setMatrimonialPostingLoading,
        setMatrimonialPostingSuccess,
        setMatrimonialPostingFail,
    } = useStore.getState();
    payload.limit = 10;
    if(isLoading){
        payload.offset = 0;
        setMatrimonialPostingLoading();
    }


    try {
        const response = await api.post(`actionToGetMatrimonialPostingByFilterApiCall`, payload);
        const matrimonialProfiles = response?.data?.data || [];

        setMatrimonialPostingSuccess({
            profiles:[...matrimonialProfiles],
            offset: payload.offset,
            totalCount: response?.data.totalCount,
        });
    } catch (error) {
        setMatrimonialPostingFail(
            error.response?.data?.message || error.message || 'Unknown error'
        );
    }
};

